import { render, staticRenderFns } from "./InvoicesHistory.vue?vue&type=template&id=3a6a643c"
import script from "./InvoicesHistory.vue?vue&type=script&lang=js"
export * from "./InvoicesHistory.vue?vue&type=script&lang=js"
import style0 from "./InvoicesHistory.vue?vue&type=style&index=0&id=3a6a643c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports